import { Button } from '@bb/ui';

/**
 * Braze-style hint about active campaigns or Canvases that stopped sending; one click filters the list to them.
 * `noun` is singular and plural, e.g. `['campaign', 'campaigns']`.
 */
export function IdleBanner({ count, idleDays, noun, onShow }: { count: number; idleDays: number; noun: [string, string]; onShow: () => void }) {
  if (count === 0) return null;
  return (
    <div className="banner" role="status">
      <span>
        {count === 1 ? `1 active ${noun[0]} has` : `${count} active ${noun[1]} have`} not sent anything in {idleDays} days.
      </span>
      <Button variant="ghost" onClick={onShow}>
        Show idle {noun[1]}
      </Button>
    </div>
  );
}
